import apiFetch from '../apiFetch'

export default function (value, token) {
  const body = {
    isDeleted: false,
    FuelTypeLanguages: value
  }
  return apiFetch({ endPoint: 'Fuel/', method: 'POST', body: body, token: token })
}
